import React from "react";
import LandingCategory from "../components/common/LandingCategory";
import { themes } from "../themes/themes";
import avatarMasculino from "../assets/images/pokemon.jpeg";
import useTrackPageView from "../hooks/useTrackPageView";
import useTimeOnPage from "../hooks/useTimeOnPage";
import { trackEvent } from "../lib/analytics";

export default function Pokemon() {
  useTrackPageView();
  useTimeOnPage();

  const handleWhatsappClick = async () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "leads",
      category: "whatsapp",
      action: "click",
      label: "geral_cta_main",
    });

    await trackEvent("whatsapp_click", {
      buttonLocation: "masculino_cta_main",
    });

    window.open("https://sendwich.pro/grupos/promosclubetcg", "_blank");
  };

  return (
    <LandingCategory
      avatar={avatarMasculino}
      titleTop="ACHADINHOS DE"
      titleBottom="POKÉMON"
      highlightWord="POKÉMON"
      members="10.000"
      description="Entre no grupo VIP e receba todos os dias ofertas de cartas, boxes, ETBs, colecionáveis e muito mais com os melhores preços! ⚡"
      whatsappLink="https://sendwich.pro/grupos/promosclubetcg" 
      telegramLink="https://t.me/seu-link"
      theme={themes.masculino}
      onWhatsappClick={handleWhatsappClick}
    />
  );
}